import { render, staticRenderFns } from "./CampaignCouponDiscountList.vue?vue&type=template&id=5f24c262"
import script from "./CampaignCouponDiscountList.vue?vue&type=script&lang=js"
export * from "./CampaignCouponDiscountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports